import React, { forwardRef } from 'react';

import { ExpandMore } from '@material-ui/icons';

import { Icon, SelectBox, SelectWrapper } from './styles';

export type SelectOption = { value: any; title: string | number };

export interface SelectProps {
  options: SelectOption[];
  placeholder?: string;
}

function Select({ options, placeholder, ...rest }, ref) {
  return (
    <SelectWrapper>
      <SelectBox ref={ref} {...rest}>
        {placeholder && (
          <option value="" disabled selected>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.title}
          </option>
        ))}
      </SelectBox>
      <Icon open={false}>
        <ExpandMore htmlColor="#8b8f93" />
      </Icon>
    </SelectWrapper>
  );
}

export default forwardRef(Select);
